// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.page-info {
    display: flex; 
    justify-content: center;
    border-radius: 10px 10px 0 0;
    background-color: var(--white-color);
    position: relative;
}
.page-info__photo__img{
    width: calc(calc(var(--space-x3) * 2) + var(--space-quarter));
    height: calc(calc(var(--space-x3) * 2) + var(--space-quarter));
    position: relative;
}
.page-info__photo__img img{
    border-radius: 50%;
    width: 100px;
    height: 100px;
}

.page-info__photo__img span.icon-ball{
    font-size: calc(var(--space-x3) + var(--space-x2));
    display: flex;
    padding: 5px;
    width: 100%;
    height: 100%;
    font-weight: var(--font-bold);
    color: var(--white-color);
    border-radius: 50%;
    justify-content: center;
    align-items: center;
}

.page-info.horizontal {
    flex-direction: row;
    display: grid;
    grid-template-columns: repeat(5,1fr);
}

.page-info .icon-ball{
    font-size: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 24));
    display: flex;
    padding: 5px;
    width: 100%;
    height: 100%;
    font-weight: var(--font-bold);
    color: var(--white-color);
    border-radius: 50%;
}

.page-info.vertical {
    padding: var(--space-and-half);
    flex-direction: column;
}

.page-info.horizontal .page-info__col2 {
    grid-column-end: end;
    grid-column-start: 2;
    padding: var(--space);
    margin-left: var(--space);
    padding-bottom: var(--space-and-half);
}

.page-info__photo {
    /* padding: 0; */
    /* margin: 0 auto; */
    position: relative;
    display: flex;
    overflow: hidden;
    border-radius: 8px;
    justify-content: center;
    /* background: var(--primary-light-color); */

}

.page-info__photo__new-button {
    position: absolute;
    width: var(--space-and-half);
    height: var(--space-and-half);
    top: 75%;
    right: 5%;
    background-color: var(--new-green-color);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-info__photo__new-button .icon-plus{
    color: white;
    font-weight: 500;
    font-size: 19;
}

.page-info__photo__edit-button{
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
}

.page-info__photo__new-button:hover {
    cursor: pointer;
    background-color: var(--active-pb-bg-color);
}

.page-info.horizontal .page-info__fullname {
    margin-top: 0;
    margin-left: var(--space-quarter);
    text-align: center;
}
.page-info.vertical .page-info__fullname {
    margin-top: var(--space);
    text-align: center;
    color: var(--primary-dark-color);
}

.page-info.horizontal .page-info__username {
    margin-top: var(--space);
    margin-left: var(--space-quarter);
    text-align: center;
}
.page-info.vertical .page-info__username {
    margin-top: var(--space);
    text-align: center;
    color: var(--basic-gray-color);
}
.page-info__col2 .page-info__description{
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
    /* color: var(--new-green-color); */
    /* cursor: pointer; */
    /* margin-left: calc(var(--space) * 4); */
}
.page-info__description.baloa-table{
    color: var(--basic-gray-color);
}

.page-info__description.baloa-table.link{
    cursor: pointer;
}

.page-info__description.baloa-hyperlink{
    color: var(--new-green-color);
    justify-content: left;
    padding-left: var(--space-x2);
    cursor: pointer;
}

.page-info.horizontal .page-info__description {
    margin-top: var(--space-half);
}

.page-info.vertical .page-info__description {
    margin-top: var(--space-and-half);
}

.page-info.horizontal .page-info__separator {
    margin-top: var(--space);
}

.page-info.vertical .page-info__separator {
    margin-top: var(--space-and-half);
}

.page-info__follows {
    margin-top: var(--space-and-half);
    display: flex;
    flex-direction: row;
    justify-content: center;
    cursor: pointer;
    flex-wrap: wrap;

}

.page-info__follows__item{
    padding-left: var(--space-and-half);
    padding-right: var(--space-and-half);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.page-info__follows__item .baloa-subtitle-2{
    color: var(--new-text-link-color);
}

.page-info__follows__item .baloa-table{
    color: #999999;
    text-transform: capitalize;
}

.page-info__follows__item.new-line{
    width: 100%;
    margin: 16px 0 0 0;
}

/* .page-info__follows p:first-child {
    margin-right: var(--space-x2);
    
}
.page-info__follows p:last-child {
    margin-left: var(--space-x2);
    
} */
.page-info__follows__following {
    width: 50%;
}
.page-info__follows__followers {
    width: 50%;
}
.page-info__action {
    position: absolute;
    bottom: calc(var(--space-x2) * -1);
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
}

.page-info__admin-buttons{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-information/PageInformationComponent.style.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,6DAA6D;IAC7D,8DAA8D;IAC9D,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kDAAkD;IAClD,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,6EAA6E;IAC7E,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,4CAA4C;;AAEhD;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,mCAAmC;IACnC,qBAAqB;IACrB,yCAAyC;AAC7C;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;;;;;GAOG;AACH;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,OAAO;IACP,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb","sourcesContent":["\n.page-info {\n    display: flex; \n    justify-content: center;\n    border-radius: 10px 10px 0 0;\n    background-color: var(--white-color);\n    position: relative;\n}\n.page-info__photo__img{\n    width: calc(calc(var(--space-x3) * 2) + var(--space-quarter));\n    height: calc(calc(var(--space-x3) * 2) + var(--space-quarter));\n    position: relative;\n}\n.page-info__photo__img img{\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n}\n\n.page-info__photo__img span.icon-ball{\n    font-size: calc(var(--space-x3) + var(--space-x2));\n    display: flex;\n    padding: 5px;\n    width: 100%;\n    height: 100%;\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-info.horizontal {\n    flex-direction: row;\n    display: grid;\n    grid-template-columns: repeat(5,1fr);\n}\n\n.page-info .icon-ball{\n    font-size: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 24));\n    display: flex;\n    padding: 5px;\n    width: 100%;\n    height: 100%;\n    font-weight: var(--font-bold);\n    color: var(--white-color);\n    border-radius: 50%;\n}\n\n.page-info.vertical {\n    padding: var(--space-and-half);\n    flex-direction: column;\n}\n\n.page-info.horizontal .page-info__col2 {\n    grid-column-end: end;\n    grid-column-start: 2;\n    padding: var(--space);\n    margin-left: var(--space);\n    padding-bottom: var(--space-and-half);\n}\n\n.page-info__photo {\n    /* padding: 0; */\n    /* margin: 0 auto; */\n    position: relative;\n    display: flex;\n    overflow: hidden;\n    border-radius: 8px;\n    justify-content: center;\n    /* background: var(--primary-light-color); */\n\n}\n\n.page-info__photo__new-button {\n    position: absolute;\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    top: 75%;\n    right: 5%;\n    background-color: var(--new-green-color);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.page-info__photo__new-button .icon-plus{\n    color: white;\n    font-weight: 500;\n    font-size: 19;\n}\n\n.page-info__photo__edit-button{\n    position: absolute;\n    right: 0;\n    top: 0;\n    cursor: pointer;\n}\n\n.page-info__photo__new-button:hover {\n    cursor: pointer;\n    background-color: var(--active-pb-bg-color);\n}\n\n.page-info.horizontal .page-info__fullname {\n    margin-top: 0;\n    margin-left: var(--space-quarter);\n    text-align: center;\n}\n.page-info.vertical .page-info__fullname {\n    margin-top: var(--space);\n    text-align: center;\n    color: var(--primary-dark-color);\n}\n\n.page-info.horizontal .page-info__username {\n    margin-top: var(--space);\n    margin-left: var(--space-quarter);\n    text-align: center;\n}\n.page-info.vertical .page-info__username {\n    margin-top: var(--space);\n    text-align: center;\n    color: var(--basic-gray-color);\n}\n.page-info__col2 .page-info__description{\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n    /* color: var(--new-green-color); */\n    /* cursor: pointer; */\n    /* margin-left: calc(var(--space) * 4); */\n}\n.page-info__description.baloa-table{\n    color: var(--basic-gray-color);\n}\n\n.page-info__description.baloa-table.link{\n    cursor: pointer;\n}\n\n.page-info__description.baloa-hyperlink{\n    color: var(--new-green-color);\n    justify-content: left;\n    padding-left: var(--space-x2);\n    cursor: pointer;\n}\n\n.page-info.horizontal .page-info__description {\n    margin-top: var(--space-half);\n}\n\n.page-info.vertical .page-info__description {\n    margin-top: var(--space-and-half);\n}\n\n.page-info.horizontal .page-info__separator {\n    margin-top: var(--space);\n}\n\n.page-info.vertical .page-info__separator {\n    margin-top: var(--space-and-half);\n}\n\n.page-info__follows {\n    margin-top: var(--space-and-half);\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    cursor: pointer;\n    flex-wrap: wrap;\n\n}\n\n.page-info__follows__item{\n    padding-left: var(--space-and-half);\n    padding-right: var(--space-and-half);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.page-info__follows__item .baloa-subtitle-2{\n    color: var(--new-text-link-color);\n}\n\n.page-info__follows__item .baloa-table{\n    color: #999999;\n    text-transform: capitalize;\n}\n\n.page-info__follows__item.new-line{\n    width: 100%;\n    margin: 16px 0 0 0;\n}\n\n/* .page-info__follows p:first-child {\n    margin-right: var(--space-x2);\n    \n}\n.page-info__follows p:last-child {\n    margin-left: var(--space-x2);\n    \n} */\n.page-info__follows__following {\n    width: 50%;\n}\n.page-info__follows__followers {\n    width: 50%;\n}\n.page-info__action {\n    position: absolute;\n    bottom: calc(var(--space-x2) * -1);\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.page-info__admin-buttons{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 24px;\n    gap: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
